<template>
  <div>
    <hd></hd>
    <div class="text-center complete  ">
        <p><i class="ico completion"></i></p>
        <h1 style="padding: 40px 0 20px;">任务发布成功</h1>
        <p>任务号：{{order_no}}， 您可继续发布任务，也可查看任务列表。</p>
        <el-button type="primary watchOrder" @click="watchOrder()">查看任务列表</el-button>
        <el-button class="continue" @click="Release()">继续发布任务</el-button>
      </div>
    <mobilefooter v-if="mobiletype"></mobilefooter>
    <ft v-else class="ft"></ft>
  </div>
</template>
<script>
import hd from '../../components/Header'
import ft from '../../components/Footer'
import api from '../../services/api.js'
import mobilefooter from '../../components/mobilefooter'

let _ = require('lodash')

export default {
  name: 'buyComplete',
  components: {
    hd: hd,
    ft: ft,
    mobilefooter: mobilefooter,
  },
  created() {
    this.order_no = this.$route.query.order_no
    this.isSingle = this.$route.query.isSingle
    if(!this.order_no) {
      this.getOrderById()
    }
    if (document.body.clientWidth < 1024) {
      this.mobiletype = true
    }
  },
  data () {
    return {
      order_no: null,
      order_id: null,
      isSingle: null,
      mobiletype: false,
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    async getOrderById () {
      this.order_id = this.$route.query.order_id
      let res = await api.getOrderById(this,{
        order_id: this.order_id
      })
      this.order_no = res.body.result.order_no
    },
    watchOrder () {
      if(this.isSingle){
        this.$router.push({ path: 'buyer/task/list'})
      }else{
        this.$router.push({ path: '/customer/task/list'})
      }
    },
    Release () {
      if(this.isSingle){
        this.$router.push({ path: '/buyer/publish_task/index'})
      }else{
        this.$router.push({ path: '/customer/publish_task/cart'})
      }
    }
  },
   watch: {
        screenWidth (val) {
          if (!this.timer) {
            this.screenWidth = val
            console.log(val)
            if (val < 1024) {
              this.mobiletype = true
            }
            else {
              this.mobiletype = false
            }
            this.timer = true
            let that = this
            setTimeout(function () {
              // that.screenWidth = tha t.$store.state.canvasWidth
              that.timer = false
            }, 400)
          }
        },
    }
    
}
</script>
<style scoped lang="scss">
  .complete {
    font-size:24px;
    font-family:PingFangSC-Regular;
    line-height:33px;
    padding: 200px 38% 50px;
    width: 100%;
    padding-bottom: 70px;
    .completion {
      background-image: url('../../ico/blueSucccess.png');
      background-position: 0 0;
      background-size: contain;
      width: 90px;
      height: 90px;
    }
    a {
      font-size: 16px;
    }

    p {
      line-height: 24px;
      color: #888
    }
    .watchOrder{
      width: 100%;
      margin: 40px 0 20px;
    }
    .continue{
      width: 100%;
      margin: 0;
      background: #fff;
      border-color: #0F66CF;
      color: #0F66CF;
    }
    .continue:hover{
        background: #fff;
        border-color: #0F66CF;
        color: #0F66CF;
    }
  }
  @media screen and (max-width:1024px){
    .complete {
      padding: 100px 10px 30px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/publish_task/Complete.vue